module.exports = __webpack_public_path__ + "static/media/settings.408440de.svg";